import { AstraMultiSelect, MultiSelectOption } from '~/astra'
import { FilterOption } from '~/store/slices/types'

export type Props<TFilterType> = {
    selectedValues: string[]
    options: MultiSelectOption<string>[]
    filterType: TFilterType
    toggleFilteredBySelection: (args: { type: TFilterType; filters: FilterOption[] }) => void
    removeAllFilterByType: (type: TFilterType) => void
    onChange?: () => void
    disableGroupSelection?: boolean
    label?: string
    placeholder?: string
    expandedGroups?: boolean
    'data-test'?: string
}

export const MultiSelectFilter = <TFilterType,>({
    selectedValues,
    filterType,
    toggleFilteredBySelection,
    removeAllFilterByType,
    onChange,
    ...restProps
}: Props<TFilterType>) => {
    const handleOnChange = (selectedOptions: FilterOption[]) => {
        if (selectedOptions.length > 0) {
            toggleFilteredBySelection({ type: filterType, filters: selectedOptions })
        } else {
            removeAllFilterByType(filterType)
        }
        if (onChange) {
            onChange()
        }
    }

    return <AstraMultiSelect values={selectedValues} onChange={handleOnChange} {...restProps} />
}
